export default function EscrowIcon() {
  return <img alt='Escrow' height='55' width='55' src='/escrow.png' style={{ borderRadius: '50%' }} />
}
